import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"Quicksand\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-quicksand\"}],\"variableName\":\"quicksand\"}");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Webkorps-Website/src/components/Providers.jsx");
